import styled from 'styled-components';

export const ReligiousSection = styled.section`
  margin: 40px 0;
  background-color: #fad0d052;
  padding: 24px 0;

  @media (max-width: 720px) {
    margin: 30px 0;
  }
`;

export const ReligiousWiseName = styled.ul`
  margin: 10px 0;
  padding: 0 20px;
  li {
    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      font-size: clamp(14px, 2vw, 16px);
      font-weight: 500;
      color: hsl(0deg, 0%, 0%, 80%);
      @media (min-width: 720px) {
        cursor: pointer;
      }
      img {
        width: 16px;
        height: 16px;
        position: relative !important;
        top: 0;
        display: block;
        right: 0;
      }
    }
  }

  .lowOpacity {
    opacity: 0.6;
  }
`;

export const SurveyResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 30% 0 0;
  img {
    width: 75%;

    // margin-bottom: 20px;
    &.confetti {
      width: 80%;
      height: auto;
      position: fixed;
      top: -50px;
    }
  }
  p {
    width: 70%;
  }
  .mainText {
    color: rgba(0, 0, 0, 0.77);
    text-align: center;
    font-size: 21px;
    font-weight: 600;
  }
  .subtext {
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
  }
  .bottom {
    background-image: linear-gradient(to bottom, #fff, #fcf0de);
    height: 180px;
    width: 100%;
    display: flex;
    position: fixed;
    bottom: 0;
    justify-content: center;
    align-items: end;
    img {
      width: 70px;
      height: 70px;
      margin-bottom: 20px;
    }
  }
  button {
    padding: 10px;
    font-size: 16px;
    font-family: 'Montserrat';
    border: none;
    color: #fff;
    font-weight: 600;
    background: #ef4e5e;
    width: 60%;
    letter-spacing: 0.5px;
    margin-top: 10px;
  }
  .pText {
    font-size: 24px;
    text-align: center;
    line-height: 30px;
    margin: auto;
    font-weight: 500;
  }

  .progress {
    border-radius: 10px;
    width: 95%;
    margin: 200px auto 30px;
    height: 10px;
    background: #dbdbdb;
    position: relative;
    &:before {
      position: absolute;
      display: block;
      content: '';
      height: 10px;
      border-radius: 10px;
      background: #63b0a8;
      animation: load 3s ease-in-out;
      @keyframes load {
        from {
          width: 0;
        }
        to {
          width: 100%;
        }
      }
    }
  }
`;

export const SurveyResultMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 36% 0 0;
  img {
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
    &.confetti {
      width: 100%;
      height: auto;
      position: fixed;
      top: -40px;
    }
  }
  p {
    width: 60%;
  }
  .mainText {
    color: rgba(0, 0, 0, 0.77);
    text-align: center;
    font-size: 21px;
    font-weight: 600;
  }
  .subtext {
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
  }
  .bottom {
    background-image: linear-gradient(to bottom, #fff, #fcf0de);
    height: 180px;
    width: 100%;
    display: flex;
    position: fixed;
    bottom: 0;
    justify-content: center;
    align-items: end;
    img {
      width: 70px;
      height: 70px;
    }
  }
  button {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    padding: 8px 16px;
    border-radius: 6px;
    background-color: #ef4e5e;
    border: none;
  }
`;
